import { axiosInstance, axiosAuthenticate } from './xhrConfig';

const News = {
  list: () =>
    axiosInstance.get(`/api/news/`),
  listWithPagination: (page) => 
    axiosInstance.get(`/api/news/?page=${page}`)
};

export default News;